import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';

/**
 * Gate an identity-requiring action (Book, Call, WhatsApp, Directions, Save)
 * behind login. Browsing the platform stays fully open, but these actions send
 * a signed-out user to the login page and return them here afterwards (PDF
 * p19-20 — same behaviour as the User App).
 */
export function useRequireAuth() {
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  return useCallback(
    (action: () => void) => {
      if (isAuthenticated) {
        action();
        return;
      }
      navigate('/login', { state: { returnTo: location.pathname + location.search } });
    },
    [isAuthenticated, navigate, location.pathname, location.search],
  );
}
